import { useContext } from 'react';
import clsx from 'clsx';

import TeamContext, {
  baseUserGroup,
  Section,
  View,
} from '@atom/components/teamPortal/TeamContext';
import TeamCreateControls from '@atom/components/teamPortal/teamControls/TeamCreateControls';
import { SearchParamType, useNavigation } from '@atom/hooks/useNavigation';
import { useTeamNavigation } from '@atom/hooks/useTeamNavigation';
import { Icon, IconButton } from '@atom/mui';
import { UserGroupTreeType } from '@atom/types/userGroups';
import { hasRolePermissions, ROLE_SETS } from '@atom/utilities/authUtilities';

import UserGroupRow from './UserGroupRow';

import classes from './userGroupTree.module.css';

const UserGroupTree = () => {
  const { teamNavigation } = useTeamNavigation();
  const { expanded } = teamNavigation;
  const [{ view }, { updateSearchParams }] = useNavigation({
    view: SearchParamType.STRING,
  });

  const { handleGroup, userGroupTree, toggleExpanded, activeGroup } =
    useContext(TeamContext);

  const handleRootGroupClick = () => {
    updateSearchParams({ view: View.DIRECTORY }, false);
    handleGroup(baseUserGroup, [
      { id: userGroupTree.id, name: userGroupTree.name },
    ]);
  };

  const icon = expanded.has(Section.DIRECTORY) ? 'expand_less' : 'expand_more';

  const handleToggleExpandDirectory = event => {
    event.stopPropagation();
    toggleExpanded(Section.DIRECTORY);
  };

  return (
    <div className={classes.treeContainer}>
      <div
        className={clsx(
          classes.row,
          classes.root,
          view === View.DIRECTORY &&
            activeGroup?.id === baseUserGroup.id &&
            classes.selected,
        )}
        onClick={handleRootGroupClick}
      >
        <div className={classes.rowContent}>
          <div className={classes.leftContent}>
            <div className={classes.nameContainer}>
              <div className={clsx(classes.title, classes.root)}>
                {baseUserGroup.name}
              </div>
            </div>
          </div>
          <div className={classes.buttonContainer}>
            {hasRolePermissions(ROLE_SETS.ORG_ADMIN) && (
              <TeamCreateControls userGroup={baseUserGroup} />
            )}
            <IconButton onClick={handleToggleExpandDirectory}>
              <Icon>{icon}</Icon>
            </IconButton>
          </div>
        </div>
      </div>
      {expanded.has(Section.DIRECTORY) && (
        <>
          {userGroupTree.userGroups.map((userGroup: UserGroupTreeType) => (
            <UserGroupRow
              key={userGroup.id}
              userGroup={userGroup}
              indentation={0}
              path={[userGroupTree, userGroup]}
            />
          ))}
        </>
      )}
    </div>
  );
};

export default UserGroupTree;
